var exports = {
  "p$": "FloatingPaneResizeHandles.module__handle___X3Fsem",
  "J3": "FloatingPaneResizeHandles.module__edgeTop___X3Fsem",
  "xf": "FloatingPaneResizeHandles.module__edgeBottom___X3Fsem",
  "Ve": "FloatingPaneResizeHandles.module__edgeLeft___X3Fsem",
  "IW": "FloatingPaneResizeHandles.module__edgeRight___X3Fsem",
  "wy": "FloatingPaneResizeHandles.module__cornerTopLeft___X3Fsem",
  "Ty": "FloatingPaneResizeHandles.module__cornerTopRight___X3Fsem",
  "AU": "FloatingPaneResizeHandles.module__cornerBottomLeft___X3Fsem",
  "pr": "FloatingPaneResizeHandles.module__cornerBottomRight___X3Fsem",
  "XX": "FloatingPaneResizeHandles.module__grip___X3Fsem",
  "eM": "FloatingPaneResizeHandles.module__gripMark___X3Fsem",
};

module.exports = exports;
